import { memo } from "react";
import { useNavigate } from "../router.js";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import CompanionComponent from "../components/CompanionComponent.jsx";

const useStyles = makeStyles((theme) => ({
	title: {
		color: theme.palette.primary.main,
		fontWeight: "bold",
		fontSize: "2.5rem"
	},
	summary: {
		fontWeight: "bold",
		fontSize: "x-large"
	},
	total: {
		fontWeight: "bold",
		fontSize: "large"
	},
	grey: {
		color: theme.palette.grey.silver,
		fontSize: "small",
		marginLeft: "0.2rem"
	},
	redStar: {
		color: theme.palette.red.main,
	}
}));

const SoloPlan = () => {
	const classes = useStyles();
	const navigate = useNavigate();

	return (
		<Grid sx={{ flex: 1, display: "flex", flexDirection: "column", mb: "1rem", minHeight: "calc(100vh - 90px)" }}>
			<Grid container justifyContent="center">
				<Grid item mt={6} sx={{ mb: { xs: 3, sm: 3, md: 3, lg: 3, xl: 0 }, textAlign: "center" }}>
					<Typography alignContent={"center"} className={classes.title}>{"Configure your solo plan"}</Typography>
				</Grid>
			</Grid>
			<Grid container flexGrow={1} display="flex" direction="row" justifyContent="center" alignItems="center" gap="5rem" pr="1rem" pl="1rem">
				<Grid item sx={{ width: "400px" }}>
					<CompanionComponent isLite />
				</Grid>
				<Grid item sx={{ width: "400px" }}>
					<CompanionComponent isUnlimited navigate={navigate} />
				</Grid>
			</Grid>
		</Grid>
           
	);
};

export default memo(SoloPlan);
